import { AxiosInstance } from 'axios';
import { BaseRepository } from '../../Utils/BaseRepository';

export class SiteRepository extends BaseRepository {
  constructor(client: AxiosInstance) {
    super(client, 'sites');
  }
}

